import types from './types';

export function clearCartMessage() {
  return {
    type: types.CLEAR_CART_MESSAGE
  }
}
